export enum EPurchaseProductType {
  Course = 'Course',
  Subscription = 'Subscription',
}

export interface ICreateOrderPayload {
  orderDetails: {
    productId: string;
    productType: EPurchaseProductType;
  }[];
}

export interface ICreateOrderResponse {
  orderId: string;
  orderCode: string;
}

export interface IConfirmBankingRequest {
  orderId: string;
  courseId: string;
}
